import styled from 'styled-components'

export const WrapperAreasProfile = styled.div`
    position: relative;
`

export const AreasGeneralSettingsWrapper = styled.div`
    padding-left: 24px;
`
export const AreasTariffSettingsWrapper = styled.div`
    padding-right: 24px;
`

export const SectionHeading = styled.h2`
    color: #282a42;
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 20px;
`

export const AreaBookingFormElementWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    border-bottom: 1px solid #e1e4ea;
`

export const AreaBookingFormElement = styled.div`
    flex-basis: calc(50% - 5px);
    padding-bottom: 20px;
    &:nth-child(odd):last-child {
        flex-basis: 100%;
    }
    &:last-child {
    }
`

export const TariffListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e1e4ea;
`

export const TariffListItemWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 14px;

    .styledBeforeIcon {
        display: inline-flex;
        align-items: center;

        & + input {
            padding-left: 24px;
        }
    }
`

export const IconContainer = styled.div`
    flex-shrink: 0;
    &:before {
        content: '';
        height: 26px;
        width: 100%;
        display: inline-flex;
    }
`

export const DeleteIconContainer = styled.button`
    margin-top: 26px;
    height: 39px;
    width: 39px;
    border-radius: 8px;
    background-color: #fff1ef;
    border: 1px solid #ed4627;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`

export const TimeSlotSettingsWrapper = styled.div`
    display: flex;
    gap: 10px;
`

export const AreaPhotosWrapper = styled.div`
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    & div[data-component-name='UploadFile'] > div {
        flex-wrap: wrap;
    }
`

export const AreaNameSettingsWrapper = styled.div`
    max-width: 50%;
    padding-block: 20px;
`

export const EquipmentListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`

export const EquipmentListTagWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: flex-start;
    width: 100%;
`

export const EquipmentListItemText = styled.span`
    display: inline-flex;
    align-items: center;
    border: 1px solid #e1e4ea;
    padding-block: 4px;
    padding-inline: 10px;
    font-size: 12px;
    color: #282a42;
    border-radius: 8px;
    font-weight: 300;
`

export const EquipmentListItemPrice = styled.span`
    font-weight: 400;
`

export const EquipmentSelectWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-end;

    & .styledBeforeIcon {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    & .styledInput {
        text-align: center;
    }
`
